/**
 * @module builder
 */
import type { MoveableItem } from '../../index'

export function filterArchived(item: MoveableItem): boolean {
  return !item.show && !item.use_total && !item.pending && !item.additionalWork
}
